export class Scroll {
    constructor() {
        console.log('Loaded Scroll')
        this._setupEvents()
    }

    _setupEvents() {
        let scrollToElements = document.querySelectorAll('[data-scrollto]');
        scrollToElements.forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                this._scrollTo(e.currentTarget.dataset.scrollto);
            });
        });
    }

    _scrollTo(target) {
        target = document.querySelector('[data-scrolltarget=' + target + ']');
        console.log(target);
        if (target) {
            const y = target.getBoundingClientRect().top +
                window.pageYOffset
            console.log('Scrolling to', y);
            //window.scrollTo({top: y, left: 0, behavior: 'smooth'});
            function fastScroll(){
                let scrollingPageInterval = setInterval(function(){
                    if (window.pageYOffset < (y-50)){
                        /*if (isMobile()){
                            window.scrollBy({
                                    top: 15,
                                    behavior: 'auto'
                                }
                            )
                            //console.log('first the window and then the element', window.pageYOffset, myGalleryAbsolutePos)
                        } else if(isTablet()){
                            window.scrollBy({
                                    top: 18,
                                    behavior: 'auto'
                                }
                            )
                        } else {*/
                        window.scrollBy({
                                top: 50,
                                behavior: 'auto'
                            }
                        )
                        //console.log('first the window and then the element', window.pageYOffset, myGalleryAbsolutePos)
                    } else {
                        {
                            clearInterval(scrollingPageInterval)
                        }
                    }

                },2)
            }
            fastScroll();
        } else {
            target = document.querySelector(target);
            if (target) {
                const y = target.getBoundingClientRect().top +
                    window.pageYOffset
                console.log('Scrolling to', y);
                //window.scrollTo({top: y, left: 0, behavior: 'smooth'});
                fastScroll();
            }
        }
    }
}
